import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3f15face"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "groups" }
const _hoisted_3 = { class: "header" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header__title" }, "Groups You Own", -1))
const _hoisted_5 = {
  key: 0,
  class: "groups__notification"
}
const _hoisted_6 = { class: "groups" }
const _hoisted_7 = { class: "groups" }
const _hoisted_8 = { class: "header" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "header__title" }, "Groups You're In", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_loader = _resolveComponent("app-loader")!
  const _component_app_search = _resolveComponent("app-search")!
  const _component_SpacesGroupDesc = _resolveComponent("SpacesGroupDesc")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.dataRequest)
      ? (_openBlock(), _createBlock(_component_app_loader, {
          key: 0,
          message: "Loading groups data ..."
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_app_search, {
          modelValue: _ctx.spacesStore.search,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spacesStore.search) = $event)),
          onClear: _cache[1] || (_cache[1] = ($event: any) => (_ctx.spacesStore.search = ''))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          (_ctx.spacesStore.filteredByNameGroupsByOwnerId.length > 0)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "header__button",
                onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goViewMyOwnGroups && _ctx.goViewMyOwnGroups(...args)), ["prevent"]))
              }, " View All "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.spacesStore.filteredByNameGroupsByOwnerId.length === 0)
          ? (_openBlock(), _createElementBlock("p", _hoisted_5, " You haven’t created any group yet. "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spacesStore.filteredByNameGroupsByOwnerId, (item) => {
            return (_openBlock(), _createBlock(_component_SpacesGroupDesc, {
              key: item.id,
              data: item
            }, null, 8, ["data"]))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            (_ctx.spacesStore.filteredByNameParticipatedGroups.length > 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "header__button",
                  onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.viewParticipatedGroups && _ctx.viewParticipatedGroups(...args)), ["prevent"]))
                }, " View All "))
              : _createCommentVNode("", true)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.spacesStore.filteredByNameParticipatedGroups, (item) => {
            return (_openBlock(), _createBlock(_component_SpacesGroupDesc, {
              key: item.id,
              data: item
            }, null, 8, ["data"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}